import * as Yup from "yup";

import {
  AdminDeleteEmployeeAccount,
  AdminDeleteEmployeeAccountVariables,
} from "_graphql/mutation/__generated__/AdminDeleteEmployeeAccount";

import { LocationGenerics } from "router/location";
import { PopUp } from "components";
import { removeEmployee } from "_graphql/visal/mutations/employee";
import toast from "react-hot-toast";
import { useMutation } from "@apollo/client";
import { useSearch } from "react-location";

export const employeeValidationSchema = Yup.object().shape({
  employee_first_name: Yup.string().required("First name is required"),
  employee_last_name: Yup.string().required("Last name is required"),
  employee_phonenumber: Yup.string().required("Phone number is required"),
  employee_email: Yup.string().required("Email is required"),
  employee_position: Yup.string().required("Position is required"),
});

export default function RemoveEmployeeContainer({
  open,
  setOpen,
  refetch,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}) {
  const searchParams = useSearch<LocationGenerics>();
  const [remove, { loading }] = useMutation<
    AdminDeleteEmployeeAccount,
    AdminDeleteEmployeeAccountVariables
  >(removeEmployee, {
    refetchQueries: ["Employees"],
  });

  const handleSubmit = async () => {
    await remove({
      variables: {
        employeeId: searchParams?.id || "",
      },
    }).then(({ data }) => {
      if (data?.adminDeleteEmployeeAccount) {
        toast.success("Employee removed successfully");
        refetch?.();
        setOpen?.(false);
      } else {
        toast.error("Failed to remove employee");
      }
    });
  };

  return (
    <PopUp
      open={open}
      setOpen={setOpen}
      title="Remove Employee"
      cancelText="No, Don't Remove Employee"
      description="This action would completely remove employee details from system"
      renderActions={() => (
        <>
          <button
            type="button"
            disabled={loading}
            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
            onClick={handleSubmit}
          >
            {loading ? "Removing Employee..." : "Remove Employee"}
          </button>
        </>
      )}
    />
  );
}
